












import {Vue, Component, Watch, Prop} from 'vue-property-decorator';

@Component({components: {}})
export default class Number extends Vue {
    @Prop({})
    number: any;
    color: any;

}
